import React, {useEffect, useState} from 'react';
import './recommended-action-list.scss';
import RecommendedAction from '../recommended-action/recommended-action';
import {observer} from 'mobx-react-lite';
import {useStores} from '../../../store';
import widgetsService from '../../../../services/widgets.service';
import {WIDGET_NAME_MAP} from '../../../../utils/widget-map';
import LoadingWrapper from '../../../shared/loading-wrapper/loading-wrapper';
import {v4 as uuidv4} from 'uuid';
import {Action, IssueDetail} from "../../../../utils/model";
import SecurityIssueDetails from "../../security-issue-details/security-issue-details";

const RecommendedActionList: React.FC = observer(() => {

    const {dashboardStore, customerStore} = useStores();

    const [actions, setActions] = useState([]);
    const [issues, setIssues] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedIssue, setSelectedIssue] = useState<IssueDetail | null>(null);

    useEffect(() => {
        if (customerStore.selectedCustomer) {
            setIsLoading(true);
            widgetsService.getWidgetData(customerStore.selectedCustomer.name,
                WIDGET_NAME_MAP.RECOMMENDED_ACTIONS,
                dashboardStore.dateRangeObj
            ).then((res) => {
                setActions(res);
                setIsLoading(false);
            })
                .catch(() => setIsLoading(false));
            setIsLoading(true);
            widgetsService.getWidgetData(customerStore.selectedCustomer.name, WIDGET_NAME_MAP.SECURITY_ISSUES_FULL, dashboardStore.dateRangeObj)
                .then((res) => {
                    setIssues(res);
                    setIsLoading(false);
                })
                .catch(() => {
                    setIsLoading(false)
                });
        }
    }, [dashboardStore.dateRangeObj, customerStore.selectedCustomer]);

    const onActionClick = (row: Action) => {
        setSelectedIssue(issues.find(item => item.id == row.id));
    };

    return (
        <>
            <div className="recommended-action-list">
                <div className="recommended-action-title">
                    Recommended Actions
                </div>
                <div className="recommended-action-items">
                    <LoadingWrapper isLoading={isLoading}
                                    skeletonProps={{count: 10, height: 65, style: {marginBottom: 15}}}>
                        {actions.map(action => (
                            <RecommendedAction key={uuidv4()} action={action} onRowClick={onActionClick}/>
                        ))}
                    </LoadingWrapper>
                </div>
            </div>
            {selectedIssue && (
                <SecurityIssueDetails
                    issue={selectedIssue}
                    onClose={() => setSelectedIssue(null)}
                    customerName={customerStore.selectedCustomer.name}
                    dateRangeObj={dashboardStore.dateRangeObj}
                />
            )}
        </>
    );
});

export default RecommendedActionList;
